import React, { useEffect } from 'react';
const profileAv = '/images/icons/profileAv2x.png';
const ApplicatIcon = '/images/icons/ApplicatIcon.svg';
const Male = '/images/icons/maleSymbol.svg';
const Female = '/images/icons/femaleSymbol.svg';
import * as _ from 'lodash';
import styles from './CMDashboard.module.css';
import { numberFormat } from '../../common/constants/NumberFormat';
import moment from 'moment';
const { leadInfo } = styles;
const BasicInfocards = ({
  coapplicant,
  bg,
  text,
  each,
  loanAmount,
  product,
  loanSubProduct
}) => {
  return (
    <div
      className={`py-3 px-3 bg-green-100 shadow-md rounded  mr-auto hover:shadow-xl ${leadInfo}`}
      style={{ backgroundColor: bg }}
    >
      <div className="ml-auto float-right">
        <span
          className="ml-auto text-green-1300 font-roboto font-normal text-sm"
          style={{ color: text }}
        >
          {each?.profession?.split('_').join(' ') || 'SALARIED'}
        </span>
      </div>
      <div className="flex w-full mt-3">
        <img className="w-12 " src={profileAv} alt="" />
        <div className="block ml-2">
          <div className="text-black-1012 font-roboto font-medium ">
            {` ${
              each?.name?.firstName ? each.name.firstName.toString() : 'NA'
            } ${each?.name?.middleName ? each.name.middleName.toString() : ''}  
            ${each?.name?.lastName ? each.name.lastName.toString() : ''}
            `}
          </div>
          <div className=" text-black-1010 flex font-roboto font-normal text-xs items-center">
            <img className="w-3 m-1" src={ApplicatIcon} alt="" />
            {each?.dob
              ? moment(_.get(each, 'dob', '')).format('DD MMM YYYY')
              : 'NA'}
            <img
              className="w-3 ml-5 mr-1"
              src={
                _.get(each, 'gender', '') == 'Male'
                  ? Male
                  : _.get(each, 'gender', '') == 'Female'
                  ? Female
                  : null
              }
            />
            {_.get(each, 'gender', 'NA')}
          </div>
        </div>
        {!coapplicant ? (
          <div className="ml-auto">
            <div className="text-green-paleGreen text-base font-roboto font-medium ml-auto mr-0 text-right">
              <span className="ml-auto text-base">
                {loanAmount ? `₹ ${numberFormat(loanAmount)}` : 'NA'}
              </span>
            </div>
            <div className=" text-black-1010 font-roboto font-normal text-xs ">
              Loan Amount Requested
            </div>
          </div>
        ) : null}
      </div>
      <div className="flex mt-3">
        <div className="block w-3/12">
          <div className="text-black-1010  font-roboto font-normal text-xs items-center">
            Marital Status
          </div>
          <div className="text-black-400 font-roboto font-normal items-center">
            {each?.maritalStatus || 'NA'}
          </div>
        </div>
        <div className="block  w-3/12">
          <div className="text-black-1010  font-roboto font-normal text-xs items-center">
            Religion
          </div>
          <div className="text-black-400 font-roboto font-normal items-center">
            {each?.religion || 'NA'}
          </div>
        </div>
        <div className="block  w-3/12">
          <div className="text-black-1010  font-roboto font-normal text-xs items-center">
            Category
          </div>
          <div className="text-black-400 font-roboto font-normal items-center">
            {each?.category || 'NA'}
          </div>
        </div>
        <div className="block  w-3/12">
          <div className="text-black-1010  font-roboto font-normal text-xs items-center">
            Resident Status
          </div>
          <div className="text-black-400 font-roboto font-normal items-center">
            {each?.residentialStatus || 'NA'}
          </div>
        </div>
      </div>
      {!coapplicant ? (
        <div className="flex w-full mt-4">
          <div className="block  w-3/12">
            <div className="text-black-1010  font-roboto font-normal text-xs items-center">
              Nature of Loan
            </div>
            <div className="text-black-400 font-roboto font-normal items-center">
              {product ? product : 'NA'}
            </div>
          </div>

          <div className="block  w-3/12">
            <div className="text-black-1010  font-roboto font-normal text-xs items-center">
              Purpose of Loan
            </div>
            <div className="text-black-400 font-roboto font-normal items-center">
              {loanSubProduct ? loanSubProduct : 'NA'}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default BasicInfocards;
